import React, { useMemo } from 'react';
import { Typography } from 'antd-v5';
import moment from 'moment';
import './styles.scss';

export const FakeChatBalloon = ({
  message,
  associate,
  storeName,
  merchantName,
  placeholderReplacements = {},
  className = '',
}) => {
  const defaultReplacements = {
    ':name:': 'John Doe',
    ':associate:': associate,
    ':store:': storeName,
    ':merchant_name:': merchantName,
    ':appointment_date:': moment().add(3, 'days').format('MMMM Do, YYYY'),
    ':appointment_time:': moment().add(3, 'days').format('h:mm A'),
    ':kiosk_link:': 'https://clbk.app/fake_kiosk_link',
    ...placeholderReplacements,
  };

  const parsedMessage = useMemo(() => {
    if (!message) return '';
    let result = message;
    Object.entries(defaultReplacements).forEach(([key, value]) => {
      result = result.replace(new RegExp(key, 'g'), value);
    });
    return result;
  }, [message, defaultReplacements]);

  return (
    <div className={`fake-chat-balloon ${className}`}>
      <Typography.Text className="align-left p-left-40" type="secondary" style={{ fontSize: '12px' }}>
        {`${associate} at ${storeName}`}
      </Typography.Text>

      <ol className="shared maw-100-P m-right-13" id="sentLink" style={{ marginBottom: '3px', marginTop: 0 }}>
        <div className="sentTextDiv">
          <li className="sent m-btm-10">
            <span className="align-left d-block">{parsedMessage}</span>
          </li>
          <span className="align-right fs-10 italic chatDateSentLink">
            {moment(new Date()).format('hh:mm a')}
          </span>
        </div>
        <img
          className="blueTail"
          src="https://dashboard-v2-images.s3.amazonaws.com/inboxV2blueTail.svg"
          alt="conversation style tail"
        />
      </ol>
    </div>
  );
};
